export default __webpack_public_path__ + "static/media/problematica.04b59bb9.png";